import axios, {
  InternalAxiosRequestConfig
} from "axios";
import {config} from "@/main";
import router from "@/router";

declare module 'axios' {
  export interface InternalAxiosRequestConfig {
    contentType?: string,
    isToken?: boolean
  }

  export interface AxiosRequestConfig {
    contentType?: string,
    isToken?: boolean
  }
}

const service = axios.create({
  baseURL: "",// api的base_url
});

/****** request拦截器==>对请求参数做处理 ******/
service.interceptors.request.use((data:InternalAxiosRequestConfig) => {
  //解决get方式不让设置Content-Type问题
  if (data.method === 'get') {
    data.data = true
  }
  data.timeout = data.timeout ? data.timeout : 10000
  data.headers['Content-Type'] = data.contentType;
  if (data.isToken) {
    data.headers.set('Authorization', `Bearer ${config.auth.getToken()}`);
  }
  return data;
}, error => {  //请求错误处理
  console.log("error：接口请求异常！！", JSON.stringify(error));
  return Promise.reject(error);
})

/****** respone拦截器==>对响应做处理 ******/
service.interceptors.response.use(
  response => {  //成功请求到数据
    let data = response.data;
    if (Object.prototype.toString.call(data).includes("Blob")) {
      // 如果是下载
      return response
    }
    if (data.code === 0) {
      return Promise.resolve(data);
    } else {
      switch (data.code) {
        case 402:
          config.dialog.toast({message: data.msg, type: "error"});
          config.auth.removeToken();
          router.push('/admin/login');
          // window.location.reload();
          return Promise.reject(data);
        case 401:
          config.dialog.toast({message: data.msg, type: "error"});
          config.auth.removeToken();
          router.push('/admin/login');
          // window.location.reload();
          return Promise.reject(data);
        default:
          console.log(data)
          return Promise.reject(data);
      }
    }
  },
  error => {
    console.log("error：接口响应异常！！", JSON.stringify(error));
    config.dialog.toast({message: "接口响应异常", type: "error"});
    return Promise.reject(error)
  }
)

export default service;
